import { gql } from "@apollo/client"
import { TRAINING_MODULE_STEP_FIELDS } from "./moduleStepFragment"

export const TRAINING_MODULE_FIELDS = gql`
  fragment TrainingModuleFields on TrainingModule {
    id
    name
    description
    createdAt
    updatedAt
    tags {
      id
      name
    }
    numberOfCourses
    steps {
      ...TrainingModuleStepFields
    }
    banner {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    type
  }
  ${TRAINING_MODULE_STEP_FIELDS}
`

export const TRAINING_MODULE_DETAIL_FIELDS = gql`
  fragment TrainingModuleDetailFields on TrainingModule {
    id
    name
    description
    steps {
      ...TrainingModuleStepFields
    }
    updatedAt
    tags {
      id
      name
    }
    author {
      id
      firstName
      lastName
      avatar {
        key
      }
    }
    lastUpdatedBy {
      id
      firstName
      lastName
      avatar {
        key
      }
    }
    banner {
      id
      key
      fileName
      fileGroup
      fileSize
    }
    type
    trainerNotesStep
    trainerRatingStep
    observationCourse {
      id
    }
  }
  ${TRAINING_MODULE_STEP_FIELDS}
`
